var moduleMap = {
	"./app": () => {
		return Promise.all([__webpack_require__.e(321), __webpack_require__.e(548), __webpack_require__.e(989), __webpack_require__.e(522), __webpack_require__.e(441), __webpack_require__.e(344), __webpack_require__.e(431), __webpack_require__.e(318), __webpack_require__.e(893)]).then(() => (() => ((__webpack_require__(58337)))));
	},
	"./webhooks-capi": () => {
		return Promise.all([__webpack_require__.e(321), __webpack_require__.e(548), __webpack_require__.e(441), __webpack_require__.e(344), __webpack_require__.e(431), __webpack_require__.e(11), __webpack_require__.e(904)]).then(() => (() => ((__webpack_require__(46293)))));
	},
	"./webhooks-lapi-pay2play": () => {
		return Promise.all([__webpack_require__.e(321), __webpack_require__.e(548), __webpack_require__.e(441), __webpack_require__.e(344), __webpack_require__.e(431), __webpack_require__.e(11), __webpack_require__.e(935)]).then(() => (() => ((__webpack_require__(82308)))));
	},
	"./webhooks-lapi-virtual-currency": () => {
		return Promise.all([__webpack_require__.e(321), __webpack_require__.e(548), __webpack_require__.e(441), __webpack_require__.e(344), __webpack_require__.e(431), __webpack_require__.e(11), __webpack_require__.e(783)]).then(() => (() => ((__webpack_require__(93956)))));
	},
	"./webhooks-lapi-virtual-items": () => {
		return Promise.all([__webpack_require__.e(321), __webpack_require__.e(548), __webpack_require__.e(441), __webpack_require__.e(344), __webpack_require__.e(431), __webpack_require__.e(11), __webpack_require__.e(428)]).then(() => (() => ((__webpack_require__(33841)))));
	},
	"./webhooks-lapi-virtual-currency-package": () => {
		return Promise.all([__webpack_require__.e(321), __webpack_require__.e(548), __webpack_require__.e(441), __webpack_require__.e(344), __webpack_require__.e(431), __webpack_require__.e(11), __webpack_require__.e(133)]).then(() => (() => ((__webpack_require__(52850)))));
	},
	"./support/free-orders": () => {
		return Promise.all([__webpack_require__.e(321), __webpack_require__.e(441), __webpack_require__.e(344), __webpack_require__.e(930)]).then(() => (() => ((__webpack_require__(33079)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});